import axios from 'axios';
// initial state
// shape: [{ id, quantity }]
const state = () => ({
    list : [],
    addNew: false,
    type: "",
    columns : [
        {
            key:"status",
            label: "status",
            display : true,
        },
        {
          key : "kooi_id",
          label : "kooi_id",
          type: "link",
          linkadder: "/kooi/",
          display : true
      },
      {
        key : "data.company.name",
        label : "company_name",
        display : true
    },
    {
        key : "data.supplier.name",
        label : "company_name",
        display : true
    },
    {
        key : "data.order_id",
        label : "order_id",
        display : true
    },
    {
        key : "data.invoice_date",
        label : "invoice_date",
        display : true
    },
    {
        key : "data.invoice_number",
        label : "invoice_number",
        display : true
    },
      ],
    loaded :false,
    isSavingNew : false,
    infinity : {
        clear: false,
        search : "",
        columns : ['kooi_id', 'status', "document_type", "document_id"],
        allLoaded : false,
        loading : true,
        loadingMore : false,
        take : 50,
    },
    workingOn : [],
})

  // getters
  const getters = {
    getById :(state) => (id) =>{
        return state.list[state.list.findIndex(item => item.id == id)]
    }
  }

  // actions
  const actions = {
    async update({commit, state, rootState}, data){
        commit("workingOn", data.product.id);
        await axios.put(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/products/" + data.product.id, data).then(response => {
            commit("update", response.data.data);
        })
        commit("doneWorkingOn", data.id);
    },
    async store({commit, state, rootState}, data){
        commit("isSavingNew", true);
        await axios.post(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/ooi", data).then(response => {
            commit("store", response.data.data);
        })
        commit("isSavingNew", false);
    },
    async load({commit, state, rootState}){
        if(state.infinity.allLoaded == false){
            commit("infinityLoading", true);
            if(state.infinity.clear == true){
                var skip = 0;
            }else{
                var skip = state.list.length;
            }
        }
        await axios.get(rootState.settings.url + "/api/v1/"+rootState.settings.internal.user_company +"/ooi", {params: {type: state.type, skip : skip, take: state.infinity.take, search : state.infinity.search}}).then((response) => {
            commit("set", response.data.data);
            commit("loaded", true);
            commit("infinityLoading", false);
        }).catch(error => {
            commit("loaded", true);
            commit("infinityLoading", false);
        })
    },
  }

  // mutations
  const mutations = {
        setType(state, type){
            state.type = type;
        },
      clean(state){
        state.list = [];
        state.loaded = false;
        state.infinity.allLoaded =false;
        state.infinity.clear = true;
        state.infinity.search = "";
        state.workingOn = [];
      },
      update(state, data){
        var index = state.list.findIndex(item => item.id == data.id);
        if(index >= 0){
            state.list[index] = data;
        }
      },
      store(state, data){
          state.list.unshift(data);
      },
      loaded(state, status){
          state.loaded = status;
      },
      set(state, list){
          state.list = list;
      },
      setSearch(state, search){
        state.infinity.loading = true;
        state.infinity.allLoaded = false;
        state.infinity.search = search;
        state.infinity.clear = true;
    },
    infinityLoading(state, status){
        state.infinity.loading = status;
    },
    setSearchValue(state, value){
        state.infinity.search = value;
    },
    workingOn(state, id){
        if(state.workingOn.findIndex(item => item == id) < 0){
            state.workingOn.push(id);
        }
        },
    doneWorkingOn(state, id){
        var index = state.workingOn.findIndex(item => item == id);
        if(index >= 0){
            state.workingOn.splice(index, 1);
        }
    },
    isSavingNew(state, status){
        state.isSavingNew = status;
    },
  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
  }
